import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ItemSetting} from "../../models/itemSetting.model";
import {ProgramLocationType} from "../../types/program-location.type";
import {CustomerType} from "../../../customers/angular/types/customer-type.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";
import {AccountModel} from "../../../account/angular/models/account.model";

export class ProgramLocationsByPackageSizeTableRowComponent implements IController {

  accountId: string;
  location: any;
  excludeLocationIds: any;
  packagesOptionsIds: string[]
  onUpdateLocation: Function;
  onDelete: Function;
  onBulkEdit: Function;
  onCreateCustomer: Function;

  public locationTypeToIconMap = {
    ACCOUNT: 'account',
    DEPOT: 'depot',
    CUSTOMER: 'customer',
    AREA: 'service-area'
  }

  public isExpanded: boolean;
  public queryPackage: string;
  public accountIds: string[];
  public isDesktop: boolean;
  public sitePackageItems: ItemSetting[];
  public packageItemOptions: ItemSetting[];
  public selectedPackagesIds: string[];
  public usedPackagesCount: number;
  public canAddPackage: boolean;
  public quantitySettingsValues: any = {};
  public customerType: typeof CustomerType = CustomerType;

  /* @ngInject */
  constructor(private splitService: SplitService, private pricePlanDialogService: PricePlanDialogService,
              private $filter, private $mdMedia) {
    this.sitePackageItems = this.splitService.getSitePackageItems();
    this.isDesktop = this.$mdMedia('gt-md');
  }

  $onInit() {
    this.usedPackagesCount = 0;
    this._setPackagesOptions();
    this._setQuantitySettingsValues();
    this._setUsedPackagesCount();
  }

  $onChanges(changes) {
    if (changes.location && !changes.location.isFirstChange()) {
      this._setQuantitySettingsValues();
      this._setUsedPackagesCount();
    }
    if (changes.packagesOptionsIds && !changes.packagesOptionsIds.isFirstChange()) {

      this._setUsedPackagesCount();
    }
    if (changes.accountId) {
      this.accountIds = this.accountId ? [this.accountId] : [];
    }
  }

  onQueryPackagesChange(query) {
    this.queryPackage = query;
  }

  getSelectedText() {
    return this.$filter('translate')(this.usedPackagesCount === 1 ? 'X_PACKAGE' : 'X_PACKAGES', {sum: this.usedPackagesCount})
  }

  onAddPackages(packageIds) {

    if (!packageIds?.length) {
      return;
    }

    _.forEach(packageIds, (id) => {
      this.location.combinedPackageSizePriceDataMap[id] = {enabled: true};
    })
    this.isExpanded = true;

    this._setPackagesOptions();
    this._setUsedPackagesCount();
    this._setQuantitySettingsValues();
    this.updateRequired();
  }

  canDeleteLocation() {
    return !_.find(this.location.combinedPackageSizePriceDataMap, (packageValue) => {
      return _.isBoolean(packageValue.parentEnabled);
    })
  }

  // name: undefined,
  // fromId: areaData.id,
  // fromEntityType: areaData.entityType,
  // toId: undefined,
  // toEntityType: undefined,
  // combinedPackageSizePriceDataMap: {}
  onLocationTypeChange(locationType: ProgramLocationType) {
    this.location.toEntityType = locationType;
    this.updateRequired();
  }

  onLocationAccountSelect(account: AccountModel) {
    this.location.toId = _.get(account, 'id');
    this.location.name = _.get(account, 'name');
    this.updateRequired();
  }

  onLocationDepotSelect(depot) {
    this.location.toId = _.get(depot, 'id');
    this.location.name = _.get(depot, 'name');
    this.updateRequired();
  }

  onLocationCustomerSelect(customer) {
    this.location.toId = _.get(customer, 'id');
    if (customer) {
      if (customer.type === this.customerType.Private) {
        this.location.name = this.$filter('userName')(customer);
      } else {
        this.location.name = customer.businessName
      }
    }
    this.updateRequired();
  }

  onLocationServiceAreaSelect(serviceArea) {
    this.location.toId = _.get(serviceArea, 'id');
    this.location.name = _.get(serviceArea, 'areaName');
    this.updateRequired();
  }

  onRemovePackage(id) {
    _.unset(this.location.combinedPackageSizePriceDataMap, id);

    this._setPackagesOptions();
    this._setUsedPackagesCount();
    this._setQuantitySettingsValues();
    this.updateRequired();
  }

  onLocationChange(updatedLocation) {
    this.location = updatedLocation;
    this.updateRequired();
  }

  changePackageStateTo(packageKey, updatedData) {
    this.location.combinedPackageSizePriceDataMap[packageKey] = updatedData;
    this.updateRequired();
  }

  // edit($event) {
  //   this.onEditLocation({$event: $event, location: this.location});
  // }

  onQuantitySettingsChange(packageId, value) {
    const updatedLocation = angular.copy(this.location);

    if (!updatedLocation.combinedPackageSizePriceDataMap[packageId].packageSizeSettings) {
      updatedLocation.combinedPackageSizePriceDataMap[packageId].packageSizeSettings = {};
    }

    if (value === 'PARENT') {
      updatedLocation.combinedPackageSizePriceDataMap[packageId].packageSizeSettings.packageSizeQuantitySettingsDefault = false;
      updatedLocation.combinedPackageSizePriceDataMap[packageId].packageSizeSettings.packageSizeQuantitySettingsParent = true;
    } else if (value === 'DEFAULT') {
      updatedLocation.combinedPackageSizePriceDataMap[packageId].packageSizeSettings.packageSizeQuantitySettingsDefault = true;
      updatedLocation.combinedPackageSizePriceDataMap[packageId].packageSizeSettings.packageSizeQuantitySettingsParent = false;
    } else {
      updatedLocation.combinedPackageSizePriceDataMap[packageId].packageSizeSettings.packageSizeQuantitySettingsDefault = false;
      updatedLocation.combinedPackageSizePriceDataMap[packageId].packageSizeSettings.packageSizeQuantitySettingsParent = false;
      // this.onSetQuantityDiscountLines(zone, areaId, oldValue, $event);
    }

    this.location = updatedLocation;
    this.updateRequired();
  }

  onEditCustom(packageKey, $event) {
    const packageRef = angular.copy(this.location.combinedPackageSizePriceDataMap[packageKey]);

    if (!packageRef.packageSizeSettings) {
      packageRef.packageSizeSettings = {};
    }

    if (!packageRef.quantitySetting) {
      packageRef.quantitySetting = {};
    }

    if (!packageRef.quantitySetting.quantityDiscountLines) {
      packageRef.quantitySetting.quantityDiscountLines = [];
    }

    const quantityDiscountLines = _.get(packageRef, 'quantitySetting.quantityDiscountLines', []);
    this.pricePlanDialogService.editPricePlanQuantityDiscountLines($event, quantityDiscountLines)
      .then((updatedQuantityDiscountLines) => {
        const updatedPackage = angular.copy(packageRef);
        updatedPackage.quantitySetting.quantityDiscountLines = updatedQuantityDiscountLines;
        updatedPackage.packageSizeSettings.packageSizeQuantitySettingsDefault = false;
        updatedPackage.packageSizeSettings.packageSizeQuantitySettingsParent = false;

        this.location.combinedPackageSizePriceDataMap[packageKey] = updatedPackage;
        this.updateRequired();
      })
      .catch(() => {
        // const areaIndex = _.findIndex(this.program.areaData, (a: any) => {
        //   return a.id === areaId;
        // })
        // const zoneIndex = _.findIndex(this.program.areaData[areaIndex].data, function (z: any) {
        //   return z.id === zone.id;
        // })
        // if (!_.isUndefined(areaIndex) && !_.isUndefined(zoneIndex) && oldValue) {
        //   const programCopy = angular.copy(this.program);
        //   if (oldValue === 'PARENT') {
        //     programCopy.areaData[areaIndex].data[zoneIndex].packageSizeSettings.packageSizeQuantitySettingsDefault = false;
        //     programCopy.areaData[areaIndex].data[zoneIndex].packageSizeSettings.packageSizeQuantitySettingsParent = true;
        //   } else if (oldValue === 'DEFAULT') {
        //     programCopy.areaData[areaIndex].data[zoneIndex].packageSizeSettings.packageSizeQuantitySettingsDefault = true;
        //     programCopy.areaData[areaIndex].data[zoneIndex].packageSizeSettings.packageSizeQuantitySettingsParent = false;
        //   } else {
        //     programCopy.areaData[areaIndex].data[zoneIndex].packageSizeSettings.packageSizeQuantitySettingsDefault = false;
        //     programCopy.areaData[areaIndex].data[zoneIndex].packageSizeSettings.packageSizeQuantitySettingsParent = false;
        //   }
        //   this.program = programCopy;
        // }
      })
  }

  private _setPackagesOptions() {
    const usedIds = _.keys(this.location.combinedPackageSizePriceDataMap);
    this.packageItemOptions = _.filter(this.sitePackageItems, (item) => {
      return _.includes(this.packagesOptionsIds, item.id) && !_.includes(usedIds, item.id);
    })

    this.selectedPackagesIds = [];
  }

  private _setQuantitySettingsValues() {
    _.forOwn(this.location.combinedPackageSizePriceDataMap, (value, key) => {
      if (_.get(this.location.combinedPackageSizePriceDataMap[key], 'packageSizeSettings.packageSizeQuantitySettingsParent', false)) {
        this.quantitySettingsValues[key] = 'PARENT';
      } else if (_.get(this.location.combinedPackageSizePriceDataMap[key], 'packageSizeSettings.packageSizeQuantitySettingsDefault', false)) {
        this.quantitySettingsValues[key] = 'DEFAULT';
      } else {
        this.quantitySettingsValues[key] = 'CUSTOM';
      }
    })
  }

  private _setUsedPackagesCount() {
    const excludeIds = _.keys(this.location.combinedPackageSizePriceDataMap);
    this.usedPackagesCount = excludeIds.length;
    this.canAddPackage = !!_.find(this.sitePackageItems, (item) => {
      return _.includes(this.packagesOptionsIds, item.id) && !_.includes(excludeIds, item.id);
    })
  }

  private updateRequired() {
    this.onUpdateLocation({location: this.location});
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programLocationsByPackageSizeTableRow', {
    require: {
      form: '^form'
    },
    bindings: {
      accountId: '<?',
      location: '<',
      excludeLocationIds: '<?',
      packagesOptionsIds: '<',
      onUpdateLocation: '&',
      onDelete: '&',
      onBulkEdit: '&',
      onCreateCustomer: '&'
    },
    template: require('./program-locations-by-package-size-table-row.html').default,
    controller: ProgramLocationsByPackageSizeTableRowComponent
  });
